<template>
  <!-- Modal -->
  <div class="modal fade" id="chartPopup" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
    <div class="modal-dialog modal-lg"  >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel"> {{ this.$parent.chartSensor ? this.$parent.chartSensor.name + '(' + this.$parent.chartSensor.description + ')' : '--' }}</h5>
          <button type="button" class="btn-close" id="close-modal" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
            <apexchart  height="400" width="99%" type="line" :options="this.$parent.chartOptions" :series="this.$parent.series"></apexchart>

        </div>

      </div>
    </div>
  </div>
</template>

<script>

import VueApexCharts from "vue3-apexcharts";

export default {
  name:'ChartPopup',
  components:{
    apexchart: VueApexCharts
  },
  computed:{

  },

  data(){
    return {
    }
  }

}
</script>

<style scoped>

.white{
  color: #FFFFFF;
}
.uploaded-bg{
  background-color: var(--dropzone-bg);
}

.modal{
  z-index: 99999;
}

.popup-form{
  text-align: left;
}

.dropzone-holder{
  border: 1px dashed var(--dropzone-border);
  padding-top:10px;
  padding-bottom:10px;
  cursor: pointer;
  color: var(--second-titles);
}

.drop-content{
  padding: 20px 10px;
}

.image-container{
  margin-top:10px;
  padding:10px;
}

progress::-moz-progress-bar {
  background: var(--components-color);
  border-radius: 5px;
  height: 6px;
}
progress::-webkit-progress-value {
  background: var(--components-color);
  border-radius: 5px;
  height: 6px;
}
progress {
  color: var(--components-color);
  border-radius: 5px;
  height: 6px;
  transition: 1.6s;
}
progress[value]{
  height: 7px;
  transition: 1.6s;
}


</style>